/* NJITG-POWER redesign interactions */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- Header scrolled state ---------- */
  function onScroll() {
    document.documentElement.classList.toggle('nj-scrolled', window.scrollY > 40);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Scroll reveal ---------- */
  var io = null;
  function initReveal(root) {
    var nodes = (root || document).querySelectorAll('[data-nj-reveal]');
    if (!('IntersectionObserver' in window) || reduce || designMode) {
      nodes.forEach(function (n) { n.classList.add('nj-reveal', 'is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    nodes.forEach(function (n) {
      if (n.dataset.njRevealBound) return;
      n.dataset.njRevealBound = '1';
      n.classList.add('nj-reveal');
      io.observe(n);
    });
  }

  /* ---------- Counters ---------- */
  function initCounters(root) {
    var els = (root || document).querySelectorAll('[data-nj-count]');
    els.forEach(function (el) {
      if (el.dataset.njCountBound) return;
      el.dataset.njCountBound = '1';
      var target = parseFloat(el.getAttribute('data-nj-count')) || 0;
      var decimals = (String(target).split('.')[1] || '').length;
      function run() {
        if (reduce) { el.textContent = target.toFixed(decimals); return; }
        var start = null, dur = 1800;
        function step(t) {
          if (!start) start = t;
          var p = Math.min((t - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (target * eased).toFixed(decimals);
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }
      if (!('IntersectionObserver' in window)) { run(); return; }
      var cio = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { run(); cio.disconnect(); }
      }, { threshold: 0.4 });
      cio.observe(el);
    });
  }

  /* ---------- Video lightbox ---------- */
  var box, frame, titleEl, lastFocus;
  var closeIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  function buildBox() {
    if (box) return;
    box = document.createElement('div');
    box.className = 'nj-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Video player');
    box.innerHTML = '<button type="button" class="nj-lightbox__close" aria-label="Close video">' + closeIcon + '</button>' +
      '<div class="nj-lightbox__frame"></div>';
    document.body.appendChild(box);
    frame = box.querySelector('.nj-lightbox__frame');
    box.querySelector('.nj-lightbox__close').addEventListener('click', closeBox);
    box.addEventListener('click', function (e) { if (e.target === box) closeBox(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && box.classList.contains('is-open')) closeBox();
    });
  }
  function embedUrl(url) {
    var m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
    if (m) return 'https://www.youtube.com/embed/' + m[1] + '?autoplay=1&rel=0';
    m = url.match(/vimeo\.com\/(\d+)/);
    if (m) return 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1';
    return null;
  }
  function openBox(src, opts) {
    opts = opts || {};
    buildBox();
    lastFocus = document.activeElement;
    frame.innerHTML = '';
    var embed = embedUrl(src);
    if (embed) {
      var ifr = document.createElement('iframe');
      ifr.src = embed;
      ifr.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
      ifr.allowFullscreen = true;
      ifr.title = opts.title || 'Video';
      frame.appendChild(ifr);
    } else {
      var v = document.createElement('video');
      v.src = src;
      v.controls = true;
      v.autoplay = true;
      v.playsInline = true;
      if (opts.poster) v.poster = opts.poster;
      frame.appendChild(v);
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    if (opts.title) {
      titleEl = document.createElement('div');
      titleEl.className = 'nj-lightbox__title';
      titleEl.textContent = opts.title;
      frame.appendChild(titleEl);
    }
    document.documentElement.classList.add('nj-lock');
    requestAnimationFrame(function () { box.classList.add('is-open'); });
    box.querySelector('.nj-lightbox__close').focus();
  }
  function closeBox() {
    if (!box) return;
    box.classList.remove('is-open');
    document.documentElement.classList.remove('nj-lock');
    setTimeout(function () { frame.innerHTML = ''; }, 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  window.NJVideo = { open: openBox, close: closeBox };

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nj-video]');
    if (!t) return;
    var src = t.getAttribute('data-nj-video');
    if (!src) return;
    e.preventDefault();
    openBox(src, { title: t.getAttribute('data-nj-video-title'), poster: t.getAttribute('data-nj-video-poster') });
  });

  /* ---------- Enhance plain <video> elements (no controls, not background) ---------- */
  var playIcon = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.14v13.72a1 1 0 0 0 1.5.86l11-6.86a1 1 0 0 0 0-1.72l-11-6.86A1 1 0 0 0 8 5.14z"/></svg>';
  function enhanceVideos(root) {
    (root || document).querySelectorAll('main video').forEach(function (v) {
      if (v.dataset.njEnhanced || v.closest('[data-nj-skip]') || v.closest('.nj-lightbox')) return;
      if (v.autoplay || v.muted && v.loop) return; // background videos stay as they are
      v.dataset.njEnhanced = '1';
      var src = v.currentSrc || v.src || (v.querySelector('source') && v.querySelector('source').src);
      if (!src) return;
      var wrap = v.parentElement;
      wrap.classList.add('nj-video-enhanced');
      v.removeAttribute('controls');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nj-play-overlay';
      btn.setAttribute('aria-label', 'Play video');
      btn.innerHTML = '<span class="nj-play">' + playIcon + '</span>';
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        v.pause();
        openBox(src, { poster: v.poster });
      });
      wrap.appendChild(btn);
    });
  }

  /* ---------- Hero slider ---------- */
  function initHero(root) {
    (root || document).querySelectorAll('[data-nj-hero]').forEach(function (hero) {
      if (hero.dataset.njBound) return;
      hero.dataset.njBound = '1';
      var slides = hero.querySelectorAll('.nj-hero__slide');
      var tabs = hero.querySelectorAll('.nj-hero__tab');
      if (!slides.length) return;
      var delay = (parseInt(hero.getAttribute('data-autoplay'), 10) || 6) * 1000;
      var idx = 0, timer = null, paused = false;
      hero.style.setProperty('--nj-hero-delay', delay + 'ms');
      function go(i) {
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          s.classList.toggle('is-active', k === idx);
          s.setAttribute('aria-hidden', k === idx ? 'false' : 'true');
        });
        tabs.forEach(function (t, k) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', k === idx ? 'true' : 'false');
          if (k === idx) { void t.offsetWidth; t.classList.add('is-active'); }
        });
        schedule();
      }
      function schedule() {
        clearTimeout(timer);
        if (paused || designMode || slides.length < 2) return;
        timer = setTimeout(function () { go(idx + 1); }, delay);
      }
      tabs.forEach(function (t, k) {
        t.addEventListener('click', function () { go(k); });
      });
      var prev = hero.querySelector('[data-nj-prev]'), next = hero.querySelector('[data-nj-next]');
      if (prev) prev.addEventListener('click', function () { go(idx - 1); });
      if (next) next.addEventListener('click', function () { go(idx + 1); });
      hero.addEventListener('mouseenter', function () { paused = true; hero.classList.add('is-paused'); clearTimeout(timer); });
      hero.addEventListener('mouseleave', function () { paused = false; hero.classList.remove('is-paused'); schedule(); });
      // swipe
      var x0 = null;
      hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 50) go(idx + (dx < 0 ? 1 : -1));
        x0 = null;
      });
      go(0);
      if (designMode) {
        document.addEventListener('shopify:block:select', function (e) {
          var b = hero.querySelector('[data-block-id="' + e.detail.blockId + '"]');
          if (b) go(Array.prototype.indexOf.call(slides, b));
        });
      }
    });
  }

  /* ---------- Solution rows: subtle tilt ---------- */
  function initTilt(root) {
    if (reduce) return;
    (root || document).querySelectorAll('[data-nj-tilt]').forEach(function (el) {
      if (el.dataset.njTiltBound) return;
      el.dataset.njTiltBound = '1';
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        el.style.transform = 'perspective(1000px) rotateY(' + (x * 6) + 'deg) rotateX(' + (-y * 6) + 'deg)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- Expanding panels ---------- */
  function initPanels(root) {
    (root || document).querySelectorAll('[data-nj-panels]').forEach(function (wrap) {
      if (wrap.dataset.njBound) return;
      wrap.dataset.njBound = '1';
      var panels = wrap.querySelectorAll('.nj-panel');
      var hoverable = window.matchMedia('(hover: hover) and (min-width: 990px)').matches;
      function activate(p) { panels.forEach(function (x) { x.classList.toggle('is-active', x === p); }); }
      panels.forEach(function (p) {
        if (hoverable) p.addEventListener('mouseenter', function () { activate(p); });
        p.addEventListener('click', function () { activate(p); });
        p.addEventListener('focus', function () { activate(p); });
        p.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(p); } });
      });
      if (designMode) document.addEventListener('shopify:block:select', function (e) {
        var b = wrap.querySelector('[data-block-id="' + e.detail.blockId + '"]'); if (b) activate(b);
      });
    });
  }

  /* ---------- Process steps: energy line fills on scroll ---------- */
  var stepEls = [];
  function initSteps(root) {
    (root || document).querySelectorAll('[data-nj-steps]').forEach(function (s) {
      if (s.dataset.njBound) return; s.dataset.njBound = '1'; stepEls.push(s);
    });
    updateSteps();
  }
  function updateSteps() {
    var vh = window.innerHeight;
    stepEls.forEach(function (s) {
      var list = s.querySelector('.nj-steps__list'); if (!list) return;
      var r = list.getBoundingClientRect();
      var p = reduce ? 1 : Math.min(Math.max((vh * 0.75 - r.top) / (r.height + vh * 0.25), 0), 1);
      s.style.setProperty('--nj-steps-p', p.toFixed(3));
      var items = s.querySelectorAll('.nj-step');
      items.forEach(function (it, i) { it.classList.toggle('is-lit', p >= (i + 0.5) / items.length - 0.02); });
    });
  }

  /* ---------- Case carousel ---------- */
  function initCases(root) {
    (root || document).querySelectorAll('[data-nj-cases]').forEach(function (sec) {
      if (sec.dataset.njBound) return; sec.dataset.njBound = '1';
      var track = sec.querySelector('[data-nj-cases-track]');
      var items = track ? track.querySelectorAll('.nj-case') : [];
      if (!items.length) return;
      var cur = sec.querySelector('[data-nj-cases-cur]'), bar = sec.querySelector('[data-nj-cases-bar]');
      var idx = 0;
      function center(i) { var it = items[i]; return it.offsetLeft - (track.clientWidth - it.offsetWidth) / 2; }
      function go(i) { idx = Math.max(0, Math.min(items.length - 1, i)); track.scrollTo({ left: center(idx), behavior: reduce ? 'auto' : 'smooth' }); }
      function sync() {
        var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bd = Infinity;
        items.forEach(function (it, i) { var d = Math.abs(it.offsetLeft + it.offsetWidth / 2 - mid); if (d < bd) { bd = d; best = i; } });
        idx = best;
        items.forEach(function (it, i) { it.classList.toggle('is-current', i === best); });
        if (cur) cur.textContent = (best + 1 < 10 ? '0' : '') + (best + 1);
        if (bar) bar.style.width = ((best + 1) / items.length * 100) + '%';
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      var p = sec.querySelector('[data-nj-cases-prev]'), n = sec.querySelector('[data-nj-cases-next]');
      if (p) p.addEventListener('click', function () { go(idx - 1); });
      if (n) n.addEventListener('click', function () { go(idx + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
      });
      // mouse drag
      var down = false, sx = 0, sl = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; sx = e.clientX; sl = track.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (Math.abs(dx) > 5) { moved = true; track.classList.add('is-drag'); }
        if (moved) track.scrollLeft = sl - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return; down = false;
        if (moved) { track.classList.remove('is-drag'); sync(); go(idx); }
      });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      sync();
    });
  }

  /* ---------- Image zoom ---------- */
  var zbox;
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nj-zoom]');
    if (!t) return;
    e.preventDefault();
    if (!zbox) {
      zbox = document.createElement('div');
      zbox.className = 'nj-zoombox';
      zbox.setAttribute('role', 'dialog'); zbox.setAttribute('aria-modal', 'true'); zbox.setAttribute('aria-label', 'Image preview');
      zbox.innerHTML = '<img alt="">';
      document.body.appendChild(zbox);
      zbox.addEventListener('click', function () { zbox.classList.remove('is-open'); document.documentElement.classList.remove('nj-lock'); });
      document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && zbox.classList.contains('is-open')) zbox.click(); });
    }
    var img = zbox.querySelector('img');
    img.src = t.getAttribute('data-nj-zoom');
    var inner = t.querySelector('img'); img.alt = inner ? inner.alt : '';
    document.documentElement.classList.add('nj-lock');
    requestAnimationFrame(function () { zbox.classList.add('is-open'); });
  });

  /* ---------- Cursor spotlight on cards ---------- */
  document.addEventListener('pointermove', function (e) {
    var c = e.target.closest && e.target.closest('[data-nj-spot], .nj-post, .nj-stat');
    if (!c) return;
    var r = c.getBoundingClientRect();
    c.style.setProperty('--mx', (e.clientX - r.left) + 'px');
    c.style.setProperty('--my', (e.clientY - r.top) + 'px');
  }, { passive: true });

  /* ---------- Magnetic buttons ---------- */
  function initMagnet(root) {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    (root || document).querySelectorAll('.nj-btn--sun, .nj-play').forEach(function (b) {
      if (b.dataset.njMag) return; b.dataset.njMag = '1';
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.translate = ((e.clientX - r.left - r.width / 2) * 0.18).toFixed(1) + 'px ' + ((e.clientY - r.top - r.height / 2) * 0.25).toFixed(1) + 'px';
      });
      b.addEventListener('pointerleave', function () { b.style.translate = ''; });
    });
  }

  /* ---------- Scroll progress + page hero parallax ---------- */
  var prog = document.createElement('div');
  prog.className = 'nj-progress'; prog.setAttribute('aria-hidden', 'true');
  function onScrollFx() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    prog.style.transform = 'scaleX(' + (h > 0 ? Math.min(window.scrollY / h, 1) : 0).toFixed(4) + ')';
    if (!reduce) document.querySelectorAll('[data-nj-ph]').forEach(function (ph) {
      var r = ph.getBoundingClientRect();
      if (r.bottom > 0) ph.style.setProperty('--nj-ph-scroll', Math.min(Math.max(-r.top / r.height, 0), 1).toFixed(3));
    });
    updateSteps();
  }
  window.addEventListener('scroll', function () { window.requestAnimationFrame(onScrollFx); }, { passive: true });
  window.addEventListener('resize', updateSteps);

  /* ---------- #ContactForm anchor → flexi contact form ---------- */
  function fixContactAnchor() {
    if (document.getElementById('ContactForm')) return;
    var f = document.querySelector('.flexi-contact-form-section, form[action*="/contact"]');
    if (!f) return;
    var a = document.createElement('div');
    a.id = 'ContactForm'; a.style.scrollMarginTop = '10rem';
    f.parentNode.insertBefore(a, f);
    if (location.hash === '#ContactForm') a.scrollIntoView();
  }

  function initAll(root) {
    initReveal(root); initCounters(root); initHero(root); initTilt(root); enhanceVideos(root);
    initPanels(root); initSteps(root); initCases(root); initMagnet(root);
    fixContactAnchor();
    if (!prog.parentNode && document.body) document.body.appendChild(prog);
    onScrollFx();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else { initAll(); }
  window.addEventListener('load', function () { enhanceVideos(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
